import { useMutation } from '@tanstack/react-query';
import { useFetch } from './utils';

export const useUploadFile = () => {
  const fetcher = useFetch();
  return useMutation({
    mutationFn: async ({ file }) => {
      const formData = new FormData();
      formData.append('file', file);
      const response = await fetcher({
        path: 'v1/surveys/files/upload/',
        method: 'POST',
        data: formData,
      });
      // Return the data object which contains gdrive_file_id, filename, and original_filename
      return response.data;
    },
  });
};

export const useCreateTranscript = () => {
  const fetcher = useFetch();
  return useMutation({
    mutationFn: async ({ data }) => {
      const response = await fetcher({
        path: 'v1/surveys/transcripts/upload/',
        method: 'POST',
        data, // This is JSON string
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response;
    },
  });
};
